import DatePicker from 'react-datepicker'

export default class Picker extends DatePicker {
    deferFocusInput = () => {
      this.cancelFocusInput()
    }
}



// WEBPACK FOOTER //
// ./src/components/datepicker/picker.js